import { useMemo } from "react";
import _isNumber from "lodash/isNumber";

import { CustomerSuccessStoryI } from "@/interfaces/strapi/collection-types";
import { Tags } from "@/components/base/cms/tags";
import { StrapiImage } from "@/components/base/cms/image";
import { clsxMerge, formatNumbers } from "shared/lib/helpers";
import { Metrics } from "@/components/base/metrics";
import { CompanyCard } from "@/modules/customer-success/story/company-card";

const Headline = ({ data }: { data?: CustomerSuccessStoryI }) => {
  const { headline } = data || {};

  return (
    !!headline && (
      <h1 className="typography-header-5-semibold sm:typography-header-3 xl:typography-header-2">
        {headline}
      </h1>
    )
  );
};

const StoryMetrics = ({ data }: { data?: CustomerSuccessStoryI }) => {
  const metrics = useMemo(() => {
    if (!data) {
      return null;
    }

    return data.result_metrics?.map(({ value, label }, idx) => ({
      valueClassName: clsxMerge(
        "typography-header-2",
        idx % 2 === 0 ? "text-[#4F8BF8]" : "text-landing-pink-80"
      ),
      value: _isNumber(value) ? formatNumbers(value) : value,
      labelClassName: "typography-body-2 text-black",
      label,
    }));
  }, [data]);

  return (
    metrics && (
      <Metrics
        className="mt-10 lg:mt-16 lg:justify-start xl:mt-[108px]"
        metrics={metrics}
      />
    )
  );
};

const Poster = ({ data }: { data?: CustomerSuccessStoryI }) => {
  const { story_img } = data || {};

  return (
    !!story_img && (
      <div className="my-6">
        <picture>
          <StrapiImage image={story_img} format="large" />
        </picture>
      </div>
    )
  );
};

export const CustomerSuccessStoryHeader = ({
  data,
}: {
  data?: CustomerSuccessStoryI;
}) => (
  <header>
    <Headline data={data} />

    <Tags className="mt-[38px] lg:mt-[26px]" tags={data?.tags} />

    {data?.company && (
      <CompanyCard
        className="mt-10 lg:hidden"
        company={data?.company.data.attributes}
      />
    )}

    <StoryMetrics data={data} />

    <Poster data={data} />
  </header>
);
